<script>
import NavBarRoutes from '@components/nav-bar/nav-bar-routes.vue';
import UsernameBlock from '@components/user/username-block.vue';
import {
  authComputed,
  mediaComputed,
  organizationComputed,
} from '@state/helpers';
import { cleverTapMixin } from '@mixins/cleverTap-mixin';
import GlobalUploader from '@/src/components/uploaders/global-uploader.vue';
import NotificationBanner from '@components/notifications/notification-banner.vue';

export default {
  components: {
    GlobalUploader,
    NavBarRoutes,
    NotificationBanner,
    UsernameBlock,
  },
  data() {
    return {
      persistentNavRoutes: [],
      viewUploader: false,
      singleRoutes: [
        {
          name: 'learning',
          title: '5-in-5',
          roles: ['isTrainer'],
        },
      ],
      loggedInNavRoutes: [
        {
          name: 'clients',
          title: 'Clients',
          roles: ['isTrainer', 'isUser'],
        },
        {
          name: 'prospects',
          title: 'Grow (Beta)',
          roles: ['isTrainer'],
        },
        {
          name: 'products',
          title: this.$store.getters['organization/organizationTitle'] + ' PAY',
          roles: ['isTrainer', 'isUser'],
        },
        {
          name: 'profile',
          title: 'Profile',
          roles: ['isTrainer', 'isUser'],
        },
        {
          name: 'trainers',
          title: 'Trainers',
          roles: ['isAdmin'],
        },
        {
          name: 'equipment',
          title: 'Equipment',
          roles: ['isAdmin'],
        },
        {
          name: 'exercises',
          title: 'Exercises',
        },
        {
          name: 'circuits',
          title: 'Circuits',
        },
        {
          name: 'workouts',
          title: 'Workouts',
        },
        {
          name: 'programs',
          title: 'Programs',
        },
        {
          name: 'recipes',
          title: 'Recipes',
        },
        {
          name: 'mealPlans',
          title: 'Meal Plans',
        },
        {
          name: 'fitnessTypes',
          title: 'Fitness Type',
          roles: ['isAdmin'],
        },
      ],
      loggedOutNavRoutes: [
        {
          name: 'login',
          title: 'Log in',
        },
        {
          name: 'register',
          title: 'Register',
        },
      ],
    };
  },
  mixins: [cleverTapMixin],
  computed: {
    ...authComputed,
    ...mediaComputed,
    ...organizationComputed,
    accessibleRoutes() {
      return this.loggedInNavRoutes.filter((route) => {
        if (
          this.roles &&
          route.roles &&
          route.roles.some((route) => this.roles.includes(route))
        ) {
          return route;
        } else if (!route.roles) {
          return route;
        }
      });
    },
    groupedAccessibleRoutes() {
      const myBusinessRoutes = [];
      const fitnessRoutes = [];
      const nutritionRoutes = [];
      const otherRoutes = [];
      this.accessibleRoutes.map((route) => {
        if (
          (route && route.name === 'exercises') ||
          route.name === 'equipment' ||
          route.name === 'circuits' ||
          route.name === 'workouts' ||
          route.name === 'programs' ||
          route.name === 'fitnessTypes'
        ) {
          fitnessRoutes.push(route);
        } else if (
          (route && route.name === 'recipes') ||
          route.name === 'mealPlans'
        ) {
          nutritionRoutes.push(route);
        } else if (
          (route && route.name === 'clients') ||
          route.name === 'products' ||
          route.name === 'profile' ||
          route.name === 'trainers' ||
          route.name === 'prospects'
        ) {
          myBusinessRoutes.push(route);
        } else {
          otherRoutes.push([route]);
        }
      });
      return {
        fitnessRoutes,
        myBusinessRoutes,
        nutritionRoutes,
        otherRoutes,
      };
    },
    totalUploadProgress() {
      let uploadProgress = 0;
      if (this.signedPostData.length > 0) {
        this.signedPostData.forEach((uploadItem) => {
          uploadProgress = uploadProgress + uploadItem.uploadProgress;
        });
        uploadProgress = uploadProgress / this.signedPostData.length;
      }
      return uploadProgress;
    },
    enableAccessibleRoutes() {
      return this.loggedIn && this.currentUser && this.currentUser.roles
        ? this.currentUser.roles.isTrainer
          ? this.currentUser.trainer.profile.subscribed // This for Trainer user
          : this.currentUser.roles.isAdmin
        : false; // This for Org user
    },
  },
  methods: {
    feedbackHandler() {
      if (
        this.currentUser &&
        this.currentUser.roles &&
        this.currentUser.roles.isTrainer
      ) {
        const trainer = this.trainerEmail;
        this.$_pushCleverTapEvent('Feedback', { trainer });
      }

      window.location.href =
        'mailto:' +
        this.organizationSupportEmail +
        '?subject=' +
        this.organizationTitle +
        ' Feedback';
    },
    showLearningLink(route) {
      if (typeof route?.title !== 'function' && route?.title === '5-in-5') {
        return this.currentUser?.trainer?.learningEnabled;
      } else {
        return true;
      }
    },
  },
};
</script>

<template>
  <div class="navbar-wrapper">
    <NotificationBanner />
    <div class="navbar-list-wrapper">
      <ul class="list-navbar">
        <li class="logo"><a href="/"><img :src="organizationLogo"/></a></li>
        <template v-for="route in persistentNavRoutes">
          <NavBarRoutes :key="route.name" :route="route" />
        </template>
        <NavBarRoutes
          v-if="enableAccessibleRoutes"
          :routeArr="userOrgId === '618183d65e84466f63c38878' ? groupedAccessibleRoutes.myBusinessRoutes.filter(route => route.name !== 'prospects') : groupedAccessibleRoutes.myBusinessRoutes"
          type="business"
        />
        <NavBarRoutes
          v-if="enableAccessibleRoutes"
          :routeArr="groupedAccessibleRoutes.fitnessRoutes"
          type="fitness"
        />
        <NavBarRoutes
          v-if="enableAccessibleRoutes"
          :routeArr="groupedAccessibleRoutes.nutritionRoutes"
          type="nutrition"
        />
        <template v-for="(routeArr, i) in groupedAccessibleRoutes.otherRoutes">
          <NavBarRoutes
            v-if="enableAccessibleRoutes"
            :key="i"
            :routeArr="routeArr"
          />
        </template>
        <template v-for="route in singleRoutes">
          <NavBarRoutes
            v-if="enableAccessibleRoutes && showLearningLink(route)"
            :key="route.name"
            :route="route"
          />
        </template>
        <template v-for="route in loggedOutNavRoutes">
          <NavBarRoutes
            v-if="!enableAccessibleRoutes"
            :key="route.name"
            :route="route"
          />
        </template>
        <BaseButton
          type="button"
          class="btn-primary btn-round"
          @click="feedbackHandler"
        >
          Feedback
        </BaseButton>

        <GlobalUploader :class="[{ isVisible: viewUploader }]" />
      </ul>
      <UsernameBlock v-if="enableAccessibleRoutes" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.uploads-container {
  position: relative;
}

::v-deep .notification-bubble {
  height: 2rem;
  left: 0;
  margin-left: 2rem;
  width: 2rem;
  z-index: 10;
}

.navbar-wrapper {
  position: fixed;
  width: 100%;
  z-index: 10;
}

.navbar-list-wrapper {
  align-items: center;
  background-color: $color-navbar-bg;
  display: flex;
  justify-content: space-between;
  padding: 0 2rem;
  position: fixed;
  width: 100%;
  z-index: 10;
}

.list-navbar {
  align-items: center;
  display: flex;
  height: 7.6rem;
  list-style-type: none;
  margin: 0;
  text-align: center;

  ::v-deep li {
    display: inline-block;
    margin-right: 2rem;

    @include media('xxxl', null) {
      margin-right: 4rem;
    }

    a {
      color: $color-link-text;
      text-decoration: none;
      text-transform: uppercase;
      transition: $duration-animation-base;

      &:hover {
        color: $color-navbar-link-text-active;
        text-decoration: none;
      }
    }

    &.logo {
      margin-top: -2px;
      width: 220px;

      &:hover {
        cursor: pointer;
      }

      img {
        width: 100%;
      }
    }

    &.router-link-active a {
      border-bottom: 3px solid $color-action;
      color: $color-navbar-link-text-active !important;
      padding-bottom: 0.5rem;
    }
  }
}
</style>
